import { useEffect, useState } from 'react';
import { intercomService } from 'modules/taboola-common-frontend-modules/intercom';
import { CounterBadge } from '../CounterBadge/CounterBadge';

export const IntercomMessageCounter = () => {
    const [count, setCount] = useState(0);

    useEffect(() => intercomService.onUnreadCountChange(setCount), []);

    if (!count) {
        return null;
    }

    return <CounterBadge count={count} />;
};
